// @flow strict

import React, { type Node } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * Twitter icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const TwitterIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H34.858V34.983H0z" />
      <path
        className="twitter"
        fill={color}
        d="M23.677 14.263c.705-.447 1.246-1.155 1.5-1.998-.66.414-1.39.714-2.168.876C22.388 12.438 21.5 12 20.518 12c-1.885 0-3.412 1.618-3.412 3.612 0 .284.028.56.087.823-2.836-.15-5.35-1.587-7.035-3.775-.294.536-.462 1.156-.462 1.818 0 1.252.603 2.358 1.519 3.007-.56-.018-1.086-.183-1.547-.451v.044c0 1.75 1.176 3.211 2.739 3.542-.287.085-.588.127-.9.127-.22 0-.435-.021-.642-.064.434 1.435 1.694 2.48 3.188 2.509-1.168.97-2.64 1.546-4.239 1.546-.275 0-.547-.016-.814-.05 1.51 1.025 3.304 1.623 5.232 1.623 6.279 0 9.71-5.505 9.71-10.279 0-.157-.002-.313-.008-.467.667-.51 1.247-1.146 1.703-1.87-.613.286-1.27.48-1.96.568z"
      />
    </g>
  );
};
